/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmailConsentCustomerDto } from '../../models/email-consent-customer-dto';
import { Response } from '../../models/response';

export interface ApiIdentityEmailconsentPut$Params {
      body?: EmailConsentCustomerDto
}

export function apiIdentityEmailconsentPut(http: HttpClient, rootUrl: string, params?: ApiIdentityEmailconsentPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
  const rb = new RequestBuilder(rootUrl, apiIdentityEmailconsentPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Response>;
    })
  );
}

apiIdentityEmailconsentPut.PATH = '/api/identity/emailconsent';
